import { PaymentMethod } from "../../../../../../Wrap/Constants/Enums/Domain/PaymentMethod";
import { PensionContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import _ from "lodash";
import { Frequency } from "../../../../../../Wrap/Constants/Enums/Domain/Frequency";
import { frequencyMap, calculateBalanceFrequency } from "../../Common/SIPP/IncomePaymentDetails/Helper/IncomePaymentHelper";
import { MoneyHelper } from "../../../../../Shared/Common/MoneyHelper";
import { IncomePaymentDestination } from "../../../../../../Wrap/Constants/Enums/Domain/IncomePaymentDestination";


// after getting data from api
export function mapWrapPensionContributionModelDataToWrapRestoreType(data: PensionContributionModel): PensionContributionModel {

    const result: PensionContributionModel = _.cloneDeep(data)

    const DrawdownIncomeAmendmentModel = data?.Contribution?.DrawdownIncomeAmendmentModel
    if (DrawdownIncomeAmendmentModel && DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction) {
        const instruction = DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction;
        instruction.Income.GrossIncomePerPayment = instruction.Income?.GrossIncomePerPayment || MoneyHelper.getDefaultMoney();
        instruction.Income.Frequency = instruction.Income.Frequency || Frequency.Monthly;
        const frequencyValue = frequencyMap[instruction.Income.Frequency] as number;

        const hasBankDestination = instruction?.Income?.IncomePaymentAllocations?.some(alloc => alloc.Destination == IncomePaymentDestination.BankAccount);
        instruction.Income.PaymentMethod = !hasBankDestination ? PaymentMethod.InternalTransfer : (instruction.Income.PaymentMethod || PaymentMethod.Faster);

        if (DrawdownIncomeAmendmentModel && DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction?.CappedArrangements) {
            DrawdownIncomeAmendmentModel.DrawdownIncomeAmendmentInstruction.CappedArrangements =
                DrawdownIncomeAmendmentModel.DrawdownIncomeAmendmentInstruction.CappedArrangements.map((arrangement) => {
                    const detail = DrawdownIncomeAmendmentModel?.PensionLevelDrawdownIncomeAmendmentCalculations?.CappedArrangementsIncomeDetail?.find((detail) => detail.ArrangementId === arrangement.PensionArrangementId) || {}
                    const balanceFrequency = calculateBalanceFrequency(
                                detail?.PensionYearStart, 
                                instruction.Income?.NextPayment, 
                                instruction.Income?.PaymentEnd, 
                                instruction.Income.Frequency
                            );

                    // MaximumIncomePaymentForRemainderOfPensionYear should be balanced by balanceFrequency
                    const maxPayment =
                        balanceFrequency > 0
                            ? (detail.GadMaximum - (detail.IncomeTakenInCurrentYear?.Amount || 0)) / balanceFrequency
                            : detail.GadMaximum - (detail.IncomeTakenInCurrentYear?.Amount || 0);
                    arrangement = {
                        ...arrangement,
                        Taxable: detail.IsNonTaxable,
                        GadMaximum: detail.GadMaximum,
                        NextYearsGadMaximum: detail.NextGadMaximum,
                        IncomeTakenToDate: detail.IncomeTakenInCurrentYear.Amount,
                        MaximumIncomePaymentForRemainderOfPensionYear: Number(maxPayment.toFixed(2)),
                        MaximumIncomePaymentForFuturePensionYears: detail.MaximumIncomePerPaymentInNextYear?.Amount,

                    }
                    return arrangement
                })
        }

        if (DrawdownIncomeAmendmentModel && DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction?.FlexiArrangements) {
            DrawdownIncomeAmendmentModel.DrawdownIncomeAmendmentInstruction.FlexiArrangements =
                DrawdownIncomeAmendmentModel.DrawdownIncomeAmendmentInstruction.FlexiArrangements.map((arrangement) => {
                    const detail = DrawdownIncomeAmendmentModel?.PensionLevelDrawdownIncomeAmendmentCalculations?.FlexiArrangementsIncomeDetail?.find((detail) => detail.ArrangementId === arrangement.PensionArrangementId) || {}
                    arrangement = {
                        ...arrangement,
                        MaximumIncomePerPayment: Number(((detail.MaximumIncomePerPayment?.Amount || 0) / frequencyValue).toFixed(2)),

                    }
                    return arrangement
                })
        }
    }


    result.Contribution.DrawdownIncomeAmendmentModel = {
        // DrawdownIncomeAmendmentCalucations: {
        //    // TODO: fix in gad wizard
        // },
        PensionLevelDrawdownIncomeAmendmentCalculations: {
            ...DrawdownIncomeAmendmentModel.PensionLevelDrawdownIncomeAmendmentCalculations
        },

        DrawdownIncomeAmendmentInstruction: {
            ...DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction
        },

        ExistingDrawdownIncome:{
            ...DrawdownIncomeAmendmentModel?.ExistingDrawdownIncome
        }
    }

    return result;
}

// before sending data to api
export function mapRestorePensionContributionModelDataToWrapType(data: PensionContributionModel): PensionContributionModel {
    const clonedData = _.cloneDeep(data)


    const result: PensionContributionModel = clonedData


    result.Contribution.DrawdownIncomeAmendmentModel = {
        PensionLevelDrawdownIncomeAmendmentCalculations: clonedData.Contribution.DrawdownIncomeAmendmentModel?.PensionLevelDrawdownIncomeAmendmentCalculations,
        DrawdownIncomeAmendmentInstruction: clonedData.Contribution.DrawdownIncomeAmendmentModel.DrawdownIncomeAmendmentInstruction
    }

    return result;
}
